import { StateParams, StateService } from '@uirouter/core';
import { IController } from 'angular';
import { UserService } from '../service.tn.user';

export class HijackUserController implements IController {
    static $inject = ['$stateParams', '$state', 'tn.user.service'];
    constructor(
        protected $stateParams: StateParams,
        protected $state: StateService,
        protected userService: UserService
    ) {
        this.userService.ready
            .then(() => {
                console.log('HijackUserController:userService.ready');
                return this.userService.hijackLogin(this.$stateParams.uid);
            })
            .then(() => this.$state.go('home'))
            .catch(() => this.$state.go('home.error'));
    }
}
